/**
 * What the campaign calls the act of logging a ride.
 *
 * Named once because it heads a page and titles several buttons; two of those
 * drifting apart would read as two features.
 */
export const CHARITY_REPORT_ACTION_LABEL = "Donate by reporting a ride";

/**
 * The same action as {@link CHARITY_REPORT_ACTION_LABEL}, shortened for the
 * header.
 *
 * The full phrase is twice the width of every other item in the bar and pushes
 * the row past the logo on a narrow screen. The page it opens states the action
 * in full, so the nav only has to get the reader there.
 */
export const CHARITY_REPORT_NAV_LABEL = "Donate a Ride";

/**
 * Where a household's own rides and its member list both live.
 *
 * One name for the bar, the page's own heading, and every instruction that
 * sends someone there — the page and the item that opens it reading
 * differently is how a reader concludes they are two places. It says
 * "household" because the rides listed are everyone's, not only the reader's.
 *
 * The household page is now a redirect onto this one, so any instruction that
 * still sends someone to "Household" names a place they cannot find in the bar.
 */
export const CHARITY_RIDES_LABEL = "My Household";

/**
 * What starting a household is called, wherever the campaign offers it.
 *
 * Named once because it had been named five ways — "Join the ride", "Join the
 * Ride", "Join", "Create a household" and "Create one" — which left a reader to
 * work out whether creating a household and joining the ride were one errand or
 * two. Every control that performs or offers the action draws its words here,
 * the page's own heading included.
 */
export const CHARITY_JOIN_ACTION_LABEL = "Join the ride";

/**
 * The same action as {@link CHARITY_JOIN_ACTION_LABEL}, shortened for the header.
 *
 * The bar states destinations in one word where it can, and the page it opens
 * says the action in full, so the nav only has to get the reader there.
 */
export const CHARITY_JOIN_NAV_LABEL = "Join";

/**
 * What taking a ride back is called.
 *
 * Named here because the guide teaches the control by name and the page draws
 * it; the guide describing a button the page does not have is how someone
 * concludes their ride cannot be undone.
 */
export const CHARITY_WITHDRAW_ACTION_LABEL = "Withdraw";

/** What amending a ride's distance is called, named once for the same reason. */
export const CHARITY_CORRECT_ACTION_LABEL = "Correct";
